import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Brand, Gather } from '../gather-typings';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GatherStateService {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private _brand$ = new BehaviorSubject<Brand>('aq');
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private _alreadySubmitted$ = new BehaviorSubject<boolean>(null);

  constructor(private titleService: Title, private translate: TranslateService) {}

  get brand(): BehaviorSubject<Brand> {
    return this._brand$;
  }

  setBrand(gather: Gather): void {
    this._brand$.next('aq');
  }

  get alreadySubmitted(): BehaviorSubject<boolean> {
    return this._alreadySubmitted$;
  }

  setAlreadySubmitted(val: boolean): void {
    if (this._alreadySubmitted$.getValue() !== val) {
      this._alreadySubmitted$.next(val);
    }
  }

  setTitle(titleTranslationKey: string): void {
    const title = String(this.translate.instant(titleTranslationKey));
    this.titleService.setTitle(title);
  }
}
